// เมนู "by Photos" — Label Scanner ที่ย้ายมาอยู่ใน BUY ทั้งตัว (31 ก.ค. 2026)
// ตัวหน้าเป็น static page /photo.html (vanilla JS ยกมาจากแอปเดิมทั้งก้อน) ฝังผ่าน iframe
// เพื่อคงพฤติกรรมเดิมครบ 100% — backend ของมันคือ /api/photo/* (CF Pages Functions)
// same-origin: หน้าใน iframe อ่าน session BUY จาก localStorage เดียวกันเอง ไม่ต้องส่งอะไรให้
export default function ByPhoto() {
  return (
    <iframe
      src="/photo?embed=1"
      title="by Photos"
      style={{ border: 0, width: '100%', height: 'calc(100dvh - 89px)', display: 'block', background: '#fff' }}
    />
  );
}
